import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/viewLayer/components/App';
import { StatsigProviderWrapper } from 'src/viewLayer/components/StatsigProviderWrapper/StatsigProviderWrapper';

const root = createRoot(document.querySelector('[data-main]'));
root.render(
  <BrowserRouter>
    <StatsigProviderWrapper >
      <App />
    </StatsigProviderWrapper>
  </BrowserRouter>
);
